import React from "react";

// Font Awesome Pro 7.3.1 duotone trash, recoloured to follow the button.
const TrashIcon = ({ className = "cf-trash-icon", size = 22 }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
    width={size}
    height={size}
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <path
      opacity=".4"
      d="M156.8 208L179.5 514.4C180.7 531.1 194.7 544 211.4 544L428.5 544C445.3 544 459.2 531.1 460.4 514.4L483.2 208L156.8 208zM245.5 128L394.5 128L383.5 91.4C381.9 86.2 377.9 82.3 373 80.7C371.4 80.4 369.8 80.1 368.2 80L273.7 80C273.1 80 272.4 80 271.8 80C270.2 80.2 268.6 80.4 267 80.7C262 82.3 258 86.2 256.5 91.4L245.5 128z"
    />
    <path d="M256.5 91.4C258.5 84.6 264.8 80 271.8 80L368.2 80C375.3 80 381.5 84.6 383.5 91.4L394.5 128L245.5 128L256.5 91.4zM212.1 128L112 128C103.2 128 96 135.2 96 144C96 152.8 103.2 160 112 160L528 160C536.8 160 544 152.8 544 144C544 135.2 536.8 128 528 128L427.9 128L414.2 82.2C408.1 61.9 389.4 48 368.2 48L271.8 48C250.6 48 231.9 61.9 225.8 82.2L212.1 128zM124.7 208L147.6 516.7C150.1 550.1 177.9 576 211.4 576L428.5 576C462 576 489.8 550.1 492.3 516.7L515.2 208L483.1 208L460.4 514.4C459.2 531.1 445.2 544 428.5 544L211.4 544C194.6 544 180.7 531.1 179.5 514.4L156.8 208L124.7 208z" />
  </svg>
);

export default TrashIcon;
